import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = comprobando, false = sin sesión, objeto = con sesión
    const [user, setUser] = useState(null);

    const check = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data.user);
        } catch {
            setAuthToken(null);
            setUser(false);
        }
    }, []);

    useEffect(() => {
        check();
    }, [check]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.access_token) setAuthToken(data.access_token);
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        if (data.access_token) setAuthToken(data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            /* ignoramos */
        }
        setAuthToken(null);
        setUser(false);
    };

    const updateUser = (partial) => setUser((u) => ({ ...u, ...partial }));

    return (
        <AuthContext.Provider value={{ user, login, register, logout, updateUser, refresh: check }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth debe usarse dentro de AuthProvider");
    return ctx;
}
